import Field from "@/components/Field";
import { NumberInput } from "@/components/ui/NumberInput";
import { memo } from "react";
import { useTranslation } from "react-i18next";

interface DurationKamFieldProps {
  required?: boolean;
  disabled?: boolean;
}

const DurationKamFieldComponent = ({
  required = false,
  disabled = false,
}: DurationKamFieldProps) => {
  const { t } = useTranslation();
  return (
    <Field
      name="kam_planned_duration"
      wrapperClassName="flex-1"
      label={t("projectSchedules.fields.kam_planned_duration")}
      required={required}
      className="space-y-2"
      render={({ field }) => (
        <NumberInput
          {...field}
          className="w-full border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          disabled={disabled}
        />
      )}
    />
  );
};

export const DurationKamField = memo(DurationKamFieldComponent);
